import type { ReactNode } from 'react';
import { User } from 'lucide-react';
import { DeceLogo } from '@/components/brand/DeceLogo';
import { Button } from '@/components/ui/button';
import { HelpDialog } from './HelpDialog';

export function BrandHeader({
  title,
  children,
}: {
  title: string;
  children?: ReactNode;
}) {
  return (
    <header className="flex items-center justify-between border-b bg-background px-6 py-3">
      <div className="flex items-center gap-4">
        <DeceLogo />
        <div className="hidden h-10 w-px bg-border md:block" aria-hidden />
        <h1 className="hidden font-serif text-lg font-semibold text-dece-navy md:block">
          {title}
        </h1>
      </div>
      <div className="flex items-center gap-2">
        <HelpDialog />
        {children ?? (
          <Button variant="ghost" size="icon" aria-label="Account">
            <User className="h-5 w-5" />
          </Button>
        )}
      </div>
    </header>
  );
}
